export const GetTodayDate = () => {
    const today = new Date();
    return `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`;
}

export const GetFirstDateOfMonth = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const month = (firstDay.getMonth() + 1).toString().padStart(2, '0');
    const day = firstDay.getDate().toString().padStart(2, '0');
    const year = firstDay.getFullYear();
    return `${month}/${day}/${year}`;
}